import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const searchPickSessionsCount = {
  name: "searchPickSessionsCount" as const,
  input: z.object({
    advancedFiltersData: z.array(AdvancedFilterDataSchema),
    search: z.string().nullish(),
    sort: z
      .object({ key: z.string(), direction: createEnum(["asc", "desc"]) })
      .nullish(),
  }),
  output: z.object({ total: z.number() }),
};

export type SearchPickSessionsCountInput = z.infer<
  typeof searchPickSessionsCount.input
>;
